import React, { ReactNode } from 'react'
import clsx from 'clsx'
import { NoResultsFound } from '../../../pages/paid-results/widgets/paid-results-table-expand-row/ui/NoResultsFound'
import { BpTooltip } from '../../components/cards/tooltip/BpTooltip'

export const cellClass = 'border-t border-t-[#E5E1EA] p-[16px]'

export const TableCell = ({
  children,
  className,
}: {
  children?: ReactNode
  className?: string
  width?: string
}) => <td className={clsx(cellClass, 'align-top', className)}>{children}</td>

interface ITableProps {
  headers: { label: string; tooltip?: string; width?: string }[]
  isEmpty: boolean
  children: ReactNode
}

export const Table = ({ headers, isEmpty, children }: ITableProps) => (
  <table className={'w-full'}>
    <thead className={'bg-focus/[.05]'}>
      <tr className={'text-[14px] text-[#8E7CA7]'}>
        {headers.map((header) => (
          <th
            key={header.label}
            className={clsx('!rounded-none py-[13px] px-[16px]')}
            style={{ width: header.width ?? 'auto' }}
          >
            <div className={'flex items-center gap-[8px]'}>
              {header.label}
              {!!header.tooltip && <BpTooltip title={header.tooltip} />}
            </div>
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {children}
      {isEmpty && <NoResultsFound colSpan={headers.length + 1} />}
    </tbody>
  </table>
)
